import { render, staticRenderFns } from "./AnnotatedText.vue?vue&type=template&id=5035ec09"
import script from "./AnnotatedText.vue?vue&type=script&lang=js"
export * from "./AnnotatedText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports